<template>
  <select-field
    v-if="showSelect"
    :customClass="layoutClass"
    :siblingError="siblingError"
    @informError="$emit('informError')"
    :name="subFields[1].name"
    @clearError="$emit('clearError')"
    :useparent="true"
    :options="stateList"
  />
  <text-field
    v-else
    :customClass="layoutClass"
    :siblingError="siblingError"
    @informError="$emit('informError')"
    @clearError="$emit('clearError')"
    :name="subFields[0].name"
    :useparent="true"
  />
</template>
<script type="text/javascript">
import TextField from "./TextField"
import SelectField from "./SelectField"
import StateCodeList from "@/utils/state-code-list"
import StateListHelper from "@/utils/state-list-helper"
import { AddressENUM } from '@/utils/address-validator';

export default {
  inheritAttrs: false,
  props: ['name', 'siblingError', 'customClass'],
  components: {
    'text-field': TextField,
    'select-field': SelectField
  },
  watch: {
    showSelect(newValue, oldValue) {
      if(newValue) {
        this.clearState();
      }
      else{
        this.clearStateCode();
      }
    },
    countryValue(newValue, oldValue) {
      if(newValue && oldValue) {
        if([newValue, oldValue].every(v => ['US', 'CA', 'IN', 'AE'].includes(v))) {
          this.clearStateCode();
        }
      }
    },
    stateFieldValue(newValue, oldValue) {
      if (newValue) {
        if (StateListHelper.canShowStateDropdown(this.$store,this.countryValue)) {
          this.clearState();
        }
      }
    }
  },
  data() {
    return {
      pName: "",
      temporaryState: []
    }
  },
  created() {
    this.pName = this.findParentForm();
    const configAddress = this.$store.getters.addresses;
      if(this.pName==AddressENUM.BILLING_ADDRESS_FIELD){
        this.temporaryState = configAddress.filter(address => address?.address_type==AddressENUM.BILLING_ADDRESS);
      }else if(this.pName==AddressENUM.SHIPPING_ADDRESS_FIELD){
        this.temporaryState = configAddress.filter(address => address?.address_type==AddressENUM.SHIPPING_ADDRESS);
      }else if(this.pName==AddressENUM.CARD_FIELD){
        this.temporaryState = configAddress.filter(address => address?.address_type==AddressENUM.CARD);
      }
  },
  computed: {
    layoutClass() {
      return this.customClass || this.$attrs.class;
    },
    config() {
      return this.$store.getters.vField_config(this.pName, this.name)
    },
    countryValue() {
      return this.cName && this.$store.getters.field_value(this.pName, this.cName);
    },
    stateFieldValue() {
      return this.cName && this.$store.getters.field_value(this.pName, this.subFields[0].name);
    },
    showSelect() {
      return StateListHelper.canShowStateDropdown(this.$store,this.countryValue);
    },
    cName() {
      return this.config && JSON.parse(this.config.meta.extra).country_name;
    },
    subFields() {
      return this.config.meta.sub_fields;
    },
    stateList() {
      // Always return an array — `showSelect && Object.entries(...)` used to
      // yield `false` when the dropdown is hidden, and clearStateCode then
      // crashed with "this.stateList.find is not a function" (Vue 3 /log/error).
      if (!this.showSelect || !StateCodeList[this.countryValue]) {
        return [];
      }

      const state = this.temporaryState && this.temporaryState[0]?.countries?.find((list) => list.country_code == this.countryValue);

      const allowedState = state?.allowed_regions?.state_code;
      const blockedState = state?.blocked_regions?.state_code;

      return Object.entries(StateCodeList[this.countryValue])
        .filter(([stateName, stateCode]) => {
          if (allowedState) {
            // If allowedState exists, only include those states in allowedState
            return allowedState.includes(stateCode);
          } else if (blockedState) {
            // If blockedState exists, exclude those states in blockedState
            return !blockedState.includes(stateCode);
          }
          // If neither allowedState nor blockedState exists, include all states
          return true;
        })
        .map(([stateName, stateCode]) => ({
          "display_name": stateName,
          "value": stateCode
        }));
    }
  },
  methods: {
    clearState() {
      this.$store.dispatch('update_form_input', {
        name: this.subFields[0].name,
        value: "",
        formName: this.pName
      });
    },
    clearStateCode() {
      if (! this.doesStateCodeBelongToCountry()) {
        this.$store.dispatch('update_form_input', {
          name: this.subFields[1].name,
          value: "",
          formName: this.pName
        });
      }
    },
    doesStateCodeBelongToCountry() {
      const stateCode = this.$store.getters.field_value(this.pName, 'state_code')
      return !!stateCode && this.stateList.some(state => state.value === stateCode)
    }
  }
}
</script>
